import React, { createContext, useContext, useEffect, useState } from 'react';
import { restoreBrowserLanguage } from '../../i18n/index';

const StaticGenerationContext = createContext(false);
export function StaticGenerationProvider({ initial = false, children }) {
  const [initialRender, setInitialRender] = useState(initial);
  useEffect(() => {
    if (initial) restoreBrowserLanguage();
    setInitialRender(false);
  }, [initial]);
  return <StaticGenerationContext.Provider value={initialRender}>{children}</StaticGenerationContext.Provider>;
}
export const useStaticGeneration = () => useContext(StaticGenerationContext);
